"use client"
import React from 'react'
import Image from 'next/image'

const MainGrid = ({ title, logoimgsrc, logoimgatl, heroimgsrc, heroimgalt, description, btnname, btnlink, featuretitle, featuredata, benefitstitle, benefitsdata, pricetitle, pricedata, whytitle, whydata, comparetitle, comparetitlegetbiz, comparedatagetbiz, comparetitleother, comparedataother, peopletitle, peopledata, peoplename, bestsuittitle, bestsuitdata }) => {
    return (

        <div className='position-relative border-black border main-grid'
            data-component="MainGrid"
            data-title={title}
            id={title.toLowerCase().replace(/\s+/g, "-").replace(/[^\w-]+/g, "")}
            style={{
                borderRadius: '25px',
                boxShadow: "0px 4px 41px 2px rgba(0, 0, 0, 0.3)",
                padding: '30px',
                marginBottom: '20px',
            }}
        >
            {/* header */}
            <div className='row mb-30 gap-x-2'>
                <div className='inline-block col-lg-3 mt-30 '>
                    {
                        logoimgsrc && logoimgatl && (
                            <Image
                                alt={logoimgatl}
                                src={logoimgsrc}
                                width={400}
                                height={400}
                                className='relative border border-black mb-10'
                                style={{ boxShadow: '0 0 20px 0 rgba(0,0,0,0.1)', borderRadius: '10px', }}
                            />
                        )
                    }
                </div>
                <div className='inline-block col-lg-5' style={{ borderRadius: '10px', padding: '20px' }}>
                    {title && (
                        <h2 className='!mb-0' style={{ marginBottom: "0px" }}><span>{title}</span></h2>
                    )}

                    <svg xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="0 0 576 512">
                        <path fill="#ecc05f" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="0 0 576 512">
                        <path fill="#ecc05f" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" />
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="0 0 576 512">
                        <path fill="#ecc05f" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" />
                    </svg>

                    <svg xmlns="http://www.w3.org/2000/svg" height="30" width="30" viewBox="0 0 576 512">
                        <path fill="#ecc05f" d="M288 0c-12.2 .1-23.3 7-28.6 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3L288 439.8 288 0zM429.9 512c1.1 .1 2.1 .1 3.2 0l-3.2 0z" />
                    </svg>
                    <span className='text-lg' style={{ fontSize: '1.5rem' }}>
                        <b>&#40;4.9&#41;</b>
                    </span>
                </div>
            </div>

            {/* hero section of component */}

            <div className='row'>
                <div className='col-lg-6 text-justify justify-center'>
                    {
                        description && (
                            <p>{description}</p>
                        )
                    }
                </div>
                <div className='col-lg-6 text-center'>
                    {
                        heroimgsrc && heroimgalt && (
                            <Image
                                alt={heroimgalt}
                                src={heroimgsrc}
                                width={500}
                                height={500}
                                className='relative'
                            // style={{borderRadius:"20px"}}
                            />
                        )
                    }
                </div>
            </div>
            {/* main content */}
            <div>
                {
                    whytitle && (
                        <h3>{whytitle}</h3>
                    )
                }
                {
                    whydata && (
                        <p>{whydata}</p>
                    )
                }
                {
                    featuretitle && (
                        <h3>{featuretitle}</h3>
                    )
                }
                {Array.isArray(featuredata) ? (
                    <div className="relative">
                        <table className='flex-wrap'>
                            <tbody>
                                {featuredata.map((data, i) => (
                                    <tr key={i} className="odd:bg-white even:bg-gray-100">
                                        <td className="px-2 py-1"><svg xmlns="http://www.w3.org/2000/svg" height="20" width="17.5" viewBox="0 0 448 512">
                                            <path fill="#63E6BE" d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" /></svg>
                                            &nbsp;{data}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    featuredata
                )}
                {/* Benefits */}
                <div>
                    <div className="flex row mt-20"
                    >
                        <div className="col-lg-9">
                            {
                                benefitstitle && (
                                    <h3>{benefitstitle}</h3>
                                )
                            }
                        </div>
                    </div>

                    <div className='flex-wrap'>
                        {Array.isArray(benefitsdata) ? (
                            <ul className="space-y-2 list-none">
                                {benefitsdata.map((data, i) => (
                                    <li key={i} className="flex items-center gap-2 text-gray-700 px-2 py-1">
                                        {data}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            benefitsdata
                        )}
                    </div>
                </div>

                <div className='mt-30 mb-30'>
                    {
                        peopletitle && (
                            <h3>{peopletitle}</h3>
                        )
                    }
                    <div className='p-4' style={{ borderRadius: '10px', boxShadow: "0 0 20px 0 rgba(0,0,0,0.1)", background: "rgb(254, 202, 202)" }}>
                        <div className='row'>
                            <div className='col-md-1 ' style={{ background: "" }}>
                                <svg xmlns="http://www.w3.org/2000/svg" width={60} height={60} viewBox="0 0 24 24" fill="currentColor" className="size-6">
                                    <path fillRule="evenodd" d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" clipRule="evenodd" />
                                </svg>
                            </div>
                            <div className='col-md-6'>

                                <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 576 512">
                                    <path fill="#ecc05f" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" />
                                </svg>

                                <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 576 512">
                                    <path fill="#ecc05f" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" />
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 576 512">
                                    <path fill="#ecc05f" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" />
                                </svg>
                                <svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 576 512">
                                    <path fill="#ecc05f" d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z" />
                                </svg>

                                <p className='mb-0'><b>{peoplename}</b></p>
                            </div>
                        </div>
                        {
                            peopledata && (
                                <p className='mt-0'>{peopledata}</p>
                            )
                        }
                    </div>
                </div>
                {
                    bestsuittitle && (
                        <h3>{bestsuittitle}</h3>
                    )
                }
                {
                    bestsuitdata && (
                        <p>{bestsuitdata}</p>
                    )
                }
                {
                    pricetitle && (
                        <h3>{pricetitle}</h3>
                    )
                }
                {
                    pricedata && (
                        <p>{pricedata}</p>
                    )
                }

            </div>
        </div >

    )
}

export default MainGrid